if (document.querySelector('.collection-hero__text-wrapper .full-description')) {
  var text = document.querySelector('.collection-hero__text-wrapper .full-description .text');
  var btn = document.querySelector('#read-more-btn');

  if (text.scrollHeight > text.clientHeight) {
    btn.classList.add('is-visible');

    // TODO: Should this be attached to the whole description or just button?
    document.querySelector('.collection-hero__text-wrapper .full-description').addEventListener('click', function () {
      btn.classList.toggle('is-visible');
      text.classList.toggle('is-visible');
    });
  }
}

